export const getCustomerDisplayName = (order) => {
    const fallback = order.customer?.email ?? '';
    const fullName = order.customer?.userId
        ? `${order.customer?.firstName ?? ''} ${order.customer?.lastName ?? ''}`.trim()
        : fallback;

    const companyName = order.customer?.companyName ? ` (${order.customer.companyName})` : '';
    return `${fullName}${companyName}`.trim();
};

export const getAdvisorDisplayName = (order) => (
    order.assignedAdvisor?.name
    || order.assignedTo?.name
    || order.bookings?.[0]?.vendorsAttendees?.[0]
    || ''
);

const getSingleItemPrice = (item) => {
    if (item.product?.type === 'subscription') {
        return item.product?.price?.yearly?.now || item.product?.price?.yearly?.standard || 0;
    }

    return item.product?.price?.now || item.product?.price?.standard || item.product?.price?.standart || 0;
};

export const calculateOrderTotal = (items = []) => items.reduce((acc, item) => acc + (getSingleItemPrice(item) * item.quantity), 0);

export const isSubscriptionOrder = (items = []) => items.some((item) => item.product?.type === 'subscription');

export const getProductsLabel = (items = []) => items
    .map((item) => item.product?.id === 'pensionanalysis-review-chatbot'
        ? `${item.product?.name} (via chatbot)`
        : item.product?.name)
    .join(', ');

export const getAffiliateProductOptions = (affiliates = [], showLegal = false) => {
    const uniqueById = new Map();

    affiliates.forEach((affiliate) => {
        const isLawAffiliate = affiliate?.id === 'jura-nord-advokater-aps';

        Object.values(affiliate?.products || {}).forEach((product) => {
            if (!product || typeof product !== 'object') return;
            const isHidden = 'hidden' in product ? Boolean(product.hidden) : false;
            const isFeatured = 'categories' in product && Array.isArray(product.categories) ? product.categories.includes('featured') : false;
            const productId = 'id' in product ? product.id : undefined;
            const productName = 'name' in product ? product.name : undefined;
            const shouldInclude = productId && productName && !isHidden && (showLegal || isLawAffiliate || isFeatured);

            if (shouldInclude && !uniqueById.has(productId)) {
                uniqueById.set(productId, { name: productName, value: productId, isLaw: isLawAffiliate });
            }
        });
    });

    return Array.from(uniqueById.values()).sort((a, b) => a.name.localeCompare(b.name));
};

export const getProductOptionGroups = (productOptions = []) => ({
    lawProductOptions: productOptions.filter((product) => product.isLaw),
    nonLawProductOptions: productOptions.filter((product) => !product.isLaw),
});
